var __TEMP__ = require('./_Hash.js');var Hash = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_ListCache.js');var ListCache = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_Map.js');var Map = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = mapCacheClear;
